import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import QS from 'qs';
import Base from './base';
import { TransmittalItem, EntityItem, UserItem, TransmittalFolderItem } from '../models';
import { TRANSMITTAL_LIMIT } from '../utils/consts';

/**
 * `Service` The transmittal service, is used to submit transmittal and fetch transmittal related data.
 */
var Transmittals = /*#__PURE__*/function (_Base) {
  /**
   * Create the transmittal service instance.
   *
   * @param sdk - the SDK instance
   */
  function Transmittals(sdk) {
    _classCallCheck(this, Transmittals);
    return _callSuper(this, Transmittals, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(Transmittals, _Base);
  return _createClass(Transmittals, [{
    key: "submitTransmittal",
    value: (
    /**
     * Submit the transmittal.
     * The response is in Camel Case format.
     *
     * @param projectId -  the project uuid
     * @param payload -, includes \{ title, message, documents, recipients \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object with the sequenceId of transmittal
     */
    function () {
      var _submitTransmittal = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, payload, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/projects/".concat(projectId, "/transmittals");
              _context.next = 3;
              return this.HttpService.dmV2.post(url, payload, config);
            case 3:
              response = _context.sent;
              return _context.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function submitTransmittal(_x, _x2, _x3) {
        return _submitTransmittal.apply(this, arguments);
      }
      return submitTransmittal;
    }()
    /**
     * Get the transmittals list.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/B360-Docs-V2.yaml/paths/~1projects~1%7BprojectId%7D~1transmittals/get
     *
     * @param projectId -  the project uuid
     * @param query -, includes offset, limit, sort, sentBy, sentByCompanyIds, recipientCompanyIds,
     *                                 beginCreatedTime, endCreatedTime, search, viewedStatus, downloadedStatus
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object with the transmittal list and pagination
     */
    )
  }, {
    key: "getTransmittals",
    value: (function () {
      var _getTransmittals = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, query, config) {
        var params, url, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              params = QS.stringify(query, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/transmittals").concat(params);
              _context2.next = 4;
              return this.HttpService.dmV2.get(url, config);
            case 4:
              response = _context2.sent;
              if (!(response.data && response.data.transmittals)) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return", {
                transmittals: response.data.transmittals.map(TransmittalItem.parseV2),
                pagination: response.data.pagination
              });
            case 7:
              return _context2.abrupt("return", null);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getTransmittals(_x4, _x5, _x6) {
        return _getTransmittals.apply(this, arguments);
      }
      return getTransmittals;
    }()
    /**
     * Get the transmittal detail.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/1d6cdbb0472a1-get-a-project-transmittal
     *
     * @param projectId -  the project uuid
     * @param transmittalId - the transmittal uuid
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object with the transmittal detail data
     */
    )
  }, {
    key: "getTransmittal",
    value: (function () {
      var _getTransmittal = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId, transmittalId, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              url = "/projects/".concat(projectId, "/transmittals/").concat(transmittalId);
              _context3.next = 3;
              return this.HttpService.dmV2.get(url, config);
            case 3:
              response = _context3.sent;
              return _context3.abrupt("return", TransmittalItem.parseV2(response.data));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getTransmittal(_x7, _x8, _x9) {
        return _getTransmittal.apply(this, arguments);
      }
      return getTransmittal;
    }()
    /**
     * Get the transmittal related documents list.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/b7c6c2ec2e780-list-project-transmittal-documents
     *
     * @param projectId -  the project uuid
     * @param transmittalId - the transmittal uuid
     * @param query -, includes limit, offset, sort, includePath, onlyRoot, transmittalFolderId
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object with the transmittal documents and pagination
     */
    )
  }, {
    key: "getDocuments",
    value: (function () {
      var _getDocuments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(projectId, transmittalId, query, config) {
        var params, url, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              params = QS.stringify(query, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/transmittals/").concat(transmittalId, "/documents").concat(params);
              _context4.next = 4;
              return this.HttpService.dmV2.get(url, config);
            case 4:
              response = _context4.sent;
              if (!(response.data && response.data.documents)) {
                _context4.next = 7;
                break;
              }
              return _context4.abrupt("return", {
                pagination: response.data.pagination,
                documents: response.data.documents.map(EntityItem.parseV2)
              });
            case 7:
              return _context4.abrupt("return", null);
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getDocuments(_x10, _x11, _x12, _x13) {
        return _getDocuments.apply(this, arguments);
      }
      return getDocuments;
    }()
    /**
     * Get the transmittal related folders.
     * The response is in Camel Case format.
     *
     * @param projectId -  the project uuid
     * @param transmittalId - the transmittal uuid
     * @param query -, includes limit, offset, sort, includePath, onlyRoot, transmittalFolderId
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object with the transmittal folders and pagination
     */
    )
  }, {
    key: "getFolders",
    value: (function () {
      var _getFolders = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(projectId, transmittalId, query, config) {
        var params, url, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              params = QS.stringify(query, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/transmittals/").concat(transmittalId, "/folders").concat(params);
              _context5.next = 4;
              return this.HttpService.dmV2.get(url, config);
            case 4:
              response = _context5.sent;
              if (!(response.data && response.data.folders)) {
                _context5.next = 7;
                break;
              }
              return _context5.abrupt("return", {
                pagination: response.data.pagination,
                folders: response.data.folders.map(TransmittalFolderItem.parseV2)
              });
            case 7:
              return _context5.abrupt("return", null);
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getFolders(_x14, _x15, _x16, _x17) {
        return _getFolders.apply(this, arguments);
      }
      return getFolders;
    }()
    /**
     * Get transmittal bread crumb
     *
     * @param projectId -  the project uuid
     * @param transmittalId - the transmittal uuid
     * @param transmittalFolderId -, transmittal folder id
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object with the transmittal folder detail
     */
    )
  }, {
    key: "getBreadCrumb",
    value: (function () {
      var _getBreadCrumb = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(projectId, transmittalId, transmittalFolderId, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              url = "/projects/".concat(projectId, "/transmittals/").concat(transmittalId, "/folders/").concat(transmittalFolderId, "?includePath=true");
              _context6.next = 3;
              return this.HttpService.dmV2.get(url, config);
            case 3:
              response = _context6.sent;
              return _context6.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getBreadCrumb(_x18, _x19, _x20, _x21) {
        return _getBreadCrumb.apply(this, arguments);
      }
      return getBreadCrumb;
    }()
    /**
     * Get all transmittal related documents list.
     * The response is in Camel Case format.
     *
     * @param projectId -  the project uuid
     * @param transmittalId - the transmittal uuid
     * @param query - limit, offset, sort, includePath, onlyRoot, transmittalFolderId
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an array with all transmittal documents
     */
    )
  }, {
    key: "getAllDocuments",
    value: (function () {
      var _getAllDocuments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(projectId, transmittalId, query, config) {
        var results, currentPagination, payload, result;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              results = [];
              currentPagination = {
                next: true,
                offset: 0
              };
            case 2:
              if (!currentPagination.next) {
                _context7.next = 16;
                break;
              }
              payload = _extends({
                offset: currentPagination.offset,
                limit: TRANSMITTAL_LIMIT.DOCUMENTS,
                sortBy: 'name',
                includePath: true
              }, query);
              _context7.next = 6;
              return this.getDocuments(projectId, transmittalId, payload, config);
            case 6:
              result = _context7.sent;
              if (result) {
                _context7.next = 11;
                break;
              }
              return _context7.abrupt("break", 16);
            case 11:
              Array.prototype.push.apply(results, result.documents);
              currentPagination.next = !!result.pagination.next;
              currentPagination.offset = result.pagination.offset + TRANSMITTAL_LIMIT.DOCUMENTS;
            case 14:
              _context7.next = 2;
              break;
            case 16:
              return _context7.abrupt("return", results);
            case 17:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getAllDocuments(_x22, _x23, _x24, _x25) {
        return _getAllDocuments.apply(this, arguments);
      }
      return getAllDocuments;
    }()
    /**
     * Get the transmittal related recipients.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/0c4ad250caa95-list-project-transmittal-recipients
     *
     * @param projectId -  the project uuid
     * @param transmittalId - the transmittal uuid
     * @param query -, includes limit, offset, sort
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object with the transmittal recipients and pagination
     */
    )
  }, {
    key: "getRecipients",
    value: (function () {
      var _getRecipients = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(projectId, transmittalId, query, config) {
        var params, url, response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              params = QS.stringify(query, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/transmittals/").concat(transmittalId, "/recipients").concat(params);
              _context8.next = 4;
              return this.HttpService.dmV2.get(url, config);
            case 4:
              response = _context8.sent;
              if (!(response.data && response.data.recipients)) {
                _context8.next = 7;
                break;
              }
              return _context8.abrupt("return", {
                isCompanyCentric: response.data.isCompanyCentric,
                pagination: response.data.pagination,
                recipients: response.data.recipients.map(UserItem.parseV2)
              });
            case 7:
              return _context8.abrupt("return", null);
            case 8:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getRecipients(_x26, _x27, _x28, _x29) {
        return _getRecipients.apply(this, arguments);
      }
      return getRecipients;
    }()
    /**
     * Update transmittals.
     * The response is in Camel Case format.
     *
     * @param projectId -  the project uuid
     * @param payload - includes \{ transmittalIds: array, displayRecipients: string \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise resolves an object with results array and errors array
     *                    \{
     *                      results: [\{ transmittalId: 'xxx' \}],
     *                      errors: [\{ id: 'xxx', code: 'xxx', title: 'xxx', detail: 'xxx' \}]
     *                    \}
     */
    )
  }, {
    key: "updateTransmittals",
    value: (function () {
      var _updateTransmittals = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(projectId, payload, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              url = "projects/".concat(projectId, "/transmittals:batch-update");
              _context9.next = 3;
              return this.HttpService.dmV2.post(url, payload, config);
            case 3:
              response = _context9.sent;
              return _context9.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function updateTransmittals(_x30, _x31, _x32) {
        return _updateTransmittals.apply(this, arguments);
      }
      return updateTransmittals;
    }()
    /**
     * Submit the transmittal from review.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Workflows-V3.yaml/paths/~1projects~1%7Bproject_id%7D~1reviews~1%7Breview_id%7D~1transmittals/post
     *
     * @param projectId -  the project uuid
     * @param reviewId -, is the review id
     * @param payload -, includes \{ title, message, documents, recipients \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object with the sequenceId of transmittal
     */
    )
  }, {
    key: "submitTransmittalFromReview",
    value: (function () {
      var _submitTransmittalFromReview = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(projectId, reviewId, payload, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/transmittals");
              _context10.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              response = _context10.sent;
              return _context10.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function submitTransmittalFromReview(_x33, _x34, _x35, _x36) {
        return _submitTransmittalFromReview.apply(this, arguments);
      }
      return submitTransmittalFromReview;
    }()
    /**
     * Submit the transmittal from package.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages~1%7BpackageId%7D~1actions/post
     *
     * @param projectId -  the project uuid
     * @param packageId -, is the package id
     * @param data -, includes \{ title, message, documents, recipients \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object with the shape \{ actionResponse: object, status: string \}
     */
    )
  }, {
    key: "submitTransmittalFromPackage",
    value: (function () {
      var _submitTransmittalFromPackage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(projectId, packageId, data, config) {
        var url, payload, response;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              url = "/projects/".concat(projectId, "/packages/").concat(packageId, "/actions");
              payload = {
                action: 'CREATE_TRANSMITTAL',
                data: data
              };
              _context11.next = 4;
              return this.HttpService.pkgV1.post(url, payload, config);
            case 4:
              response = _context11.sent;
              return _context11.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function submitTransmittalFromPackage(_x37, _x38, _x39, _x40) {
        return _submitTransmittalFromPackage.apply(this, arguments);
      }
      return submitTransmittalFromPackage;
    }()
    /**
     * Get the transmittal related documents list.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/0137abf87351a-verify-the-email-and-code-for-the-transmittal-non-members
     *
     * @param transmittalId - the transmittal uuid
     * @param email - Required. This email should be in the transmittal's non-member recipient list. If yes, return 200. If not, return the 400 error.
     * @param code - If the code is sent, then the code must be the same as the one sent to the above email.
     * When the request body contains both email and code, if the email and code are matched, it will send the response with http status code 202.
     * @param config - Configurable object for overwrite request parameters.
     * @returns token and nonMemberDetail
     */
    )
  }, {
    key: "verifyNonMember",
    value: (function () {
      var _verifyNonMember = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(transmittalId, email, code, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              url = "/transmittals/".concat(transmittalId, "/non-members:verify");
              _context12.next = 3;
              return this.HttpService.dmV3.post(url, {
                email: email,
                code: code
              }, config);
            case 3:
              response = _context12.sent;
              return _context12.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function verifyNonMember(_x41, _x42, _x43, _x44) {
        return _verifyNonMember.apply(this, arguments);
      }
      return verifyNonMember;
    }()
    /**
     * Update the non-member's detail.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/2624bad316907-update-the-non-member-s-detail
     *
     * @param transmittalId - the transmittal uuid
     * @param payload - includes \{ firstName: string, lastName: string, companyName: string, role: string \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object with the shape \{ \}
     */
    )
  }, {
    key: "updateNonMemberDetail",
    value: (function () {
      var _updateNonMemberDetail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(transmittalId, payload, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              url = "/transmittals/".concat(transmittalId, "/non-members");
              _context13.next = 3;
              return this.HttpService.dmV3.put(url, payload, config);
            case 3:
              response = _context13.sent;
              return _context13.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function updateNonMemberDetail(_x45, _x46, _x47) {
        return _updateNonMemberDetail.apply(this, arguments);
      }
      return updateNonMemberDetail;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Transmittals';
    }
  }]);
}(Base);
export default Transmittals;